var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcnPdf = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4766 11H22.7734L14.4766 2.77344V11ZM4 0.523438H16.0234L25.0234 9.52344V27.5234C25.0234 28.3203 24.7188 29.0234 24.1094 29.6328C23.5 30.1953 22.7969 30.4766 22 30.4766H4C3.20312 30.4766 2.5 30.1953 1.89062 29.6328C1.28125 29.0234 0.976562 28.3203 0.976562 27.5234L1.04688 3.47656C1.04688 2.67969 1.32812 2 1.89062 1.4375C2.5 0.828125 3.20312 0.523438 4 0.523438Z",
    fill: "#222222"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnPdf, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn-pdf.13f21990.svg";
export { ForwardRef as ReactComponent };